import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_KEY_STUDENT_SKIP_JUMP_IN_SETTING = gql`
  mutation updateKeyStudentSettingSkipJumpIn($data: [UpdateKeyStudentSettingSkipJumpInInput!]!) {
    updateKeyStudentSettingSkipJumpIn(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_STUDENT_SKIP_JUMP_IN_SETTING;
